var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-list"},[_c('ul',_vm._l((_vm.templates),function(template,index){return _c('li',{key:index},[_c('div',{staticClass:"template-view"},[_c('span',{staticClass:"template-name"},[_vm._v(_vm._s(template.title))]),_c('span',[_vm._v(_vm._s(template.type))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }